import React from 'react';
import "./index.less"
class MyWifi extends React.Component<any,any> {
  render() {
    return <div className="wlan_no">
      <img src={require("../../images/wlan.svg")} alt="" />
      <div className="wlan_lg">亲，网络不给力哦～</div>
      <div className="wlan_sm">请检查网络设置</div>
      {/*<div className="wlan_btn" onClick={() => { location.reload() }}>刷新</div>*/}
    </div>
  }
}

export default MyWifi;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/mywifi/index.tsx